import styled from 'styled-components'

import { fontFamily } from '../../../../global.style'

export const Container = styled.div`
  min-height: 262px;
  display: flex;
  padding: 33px 130px;
  align-items: center;
  gap: 30px;

  background: linear-gradient(116deg, #B81570 22.96%, #CC092F 112.26%);

  @media(max-width: 767px) {
    flex-direction: column;
    padding: 24px 50px;
    align-items: flex-start;
  }
`

export const TitleContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  h1 {
    font-family: ${fontFamily.brand};
    color: #fff;
    font-size: 32px;
    font-style: normal;
    font-weight: 500;
    line-height: 46px;

    @media(max-width: 767px) {
      font-size: 24px;
    }
  }

  h2 {
    width: 80%;
  
    font-family: ${fontFamily.brand};
    color: #fff;
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: 35px;

    @media(max-width: 767px) {
      font-size: 20px;
      font-weight: 400;
    }
  }
`

export const BodyContent = styled.div`
  flex: 1;

  display: flex;
  flex-direction: column;
  gap: 20px;

  @media(max-width: 767px) {
    gap: 10px;
  }
`

export const Topics = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 5px;
`

export const Item = styled.div`
  margin-bottom: 5px;
  display: flex;
  align-items: start;
  gap: 24px;

  img {
    position: relative;
    top: 7px;
  }

  span {
    -webkit-font-smoothing: antialiased;
    font-family: ${fontFamily.brand};
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 30px;
    color: #fff;
  }
`

export const TextIntro = styled.span`
  font-family: 'Platform Web';
  line-height: 21px;
  color: #fff;
  font-weight: 500;
  font-size: 14px;
`;